import React, { useEffect, useRef, useState } from 'react';
import PageHelmet from '../components/helmet/PageHelmet';
import { useDispatch, useSelector } from 'react-redux';
import { globalStatistic } from '../redux/actions/otherActions';
import { getPageSeo } from '../redux/actions/pageActions';
import { getLoyaltyProducts, getLoyaltySettings } from '../redux/actions/productActions';

const LoyaltyShopIframeLandingPage = () => {

    const dispatch = useDispatch();
    const [pageSeoData, setPageSeoData] = useState({});
    // Pragovi (188/488/4.888/18.888 EUR) su na statickoj stranici (public/loyalty-landing/)
    // hardkodovan tekst - da bi bili stvarni, ova (React) strana ucitava prave podatke preko
    // istih akcija koje koristi i /loyalty-artikli, pa ih postMessage-om salje unutra u iframe.
    // Isti izvor kao svuda u Joker logici: loyaltySettings.anCompanyTarget (188) + redom prvi/
    // drugi/treci Condition u specialShopListGroup su Deal/Super/Premium (vidi LoyaltySpecialConditionGroup.js).
    const loyaltySettings = useSelector((state) => state.getLoyaltySettings);
    const loyaltyProductsList = useSelector((state) => state.getLoyaltyProducts);
    const iframeRef = useRef(null);
    const [isIframeReady, setIsIframeReady] = useState(false);

    useEffect(() => {
        dispatch(getPageSeo(363)).then(res => {
            if (res) {
                setPageSeoData(res);
            }
        });
        dispatch(globalStatistic(363, 'PAGE'));
        dispatch(getLoyaltySettings(1));
        dispatch(getLoyaltyProducts(1));
    }, []);

    useEffect(() => {
        if (!isIframeReady) return;
        // Sortirano po pragu - backend ne garantuje redosled grupa (vidi LoyaltyShopPage.js)
        const groups = [...(loyaltyProductsList?.specialShopListGroup || [])]
            .sort((a, b) => (a.anConditionLimit ?? 0) - (b.anConditionLimit ?? 0));
        if (!loyaltySettings?.anCompanyTarget || !groups.length) return;
        iframeRef.current?.contentWindow?.postMessage({
            type: 'loyalty-thresholds',
            entry: loyaltySettings.anCompanyTarget,
            deal: groups[0]?.anConditionLimit,
            super: groups[1]?.anConditionLimit,
            premium: groups[2]?.anConditionLimit,
        }, window.location.origin);
    }, [isIframeReady, loyaltySettings, loyaltyProductsList]);

    return (
        <>
            {Object.keys(pageSeoData).length !== 0 &&
                <PageHelmet
                    title={pageSeoData ? `${pageSeoData.acSeoTitle}` : "Ewe Comp"}
                    description={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
                    keywords={pageSeoData ? `${pageSeoData.acSeoKeywords}` : ""}
                    ogDescription={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
                    ogTitle={pageSeoData ? `${pageSeoData.acSeoTitle}` : ""}
                    ogUrl={pageSeoData ? `https://ewe.rs/${pageSeoData.acSeoUrl}` : ""}
                    ogImg="https://www.ewe.rs/media/ewe-og-img.jpg"
                    ogType="article"
                    twitterDescription={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
                />
            }
            <iframe
                ref={iframeRef}
                title="loyalty-pocetna"
                src={`${process.env.PUBLIC_URL}/loyalty-landing/index.html`}
                style={{ width: '100%', height: '100vh', border: 'none', display: 'block' }}
                loading="lazy"
                onLoad={() => setIsIframeReady(true)}
            />
        </>
    );
};

export default LoyaltyShopIframeLandingPage;
